import { b as __spreadArrays } from './tslib.es6-896f83a9.js';

var filterDistinct = function (array) { return __spreadArrays(Array.from(new Set(array))); };

export { filterDistinct as f };
//# sourceMappingURL=filterDistinct-c0340793.js.map
